const sp = {
	login: 'Iniciar sesión',
	logout: 'Cerrar sesión',
	signin: 'Registrarse',
	signup: 'Regístrate',
	email: 'correo electrónico',
	emailAddr: 'Dirección de correo electrónico',
	password: 'contraseña',
	rememberMe: 'Recuérdame',
	forgotYourPwd: '¿Olvidaste tu contraseña?',
	signinFacebook: 'Iniciar sesión usando Facebook',
	signinGoogle: 'Inicia sesión con Google',
	dontAccount: '¿No tienes una cuenta?',
	firstName: 'Nombre de pila',
	lastName: 'Apellido',
	confirmPwd: 'Confirmar contraseña',
	signup_msg: 'Al hacer clic en unirse ahora, acepta el',
	digitX_user_agreement: 'Acuerdo de usuario de DigitXchange',
	privacy_policy: 'Política de privacidad',
	and: ' y ',
	cookies_policy: 'Política de cookies',
	have_account: 'Ya tienes una cuenta',
	forgotPwd: 'Contraseña olvidada',
	recoverPwd: 'RECUPERAR CONTRASEÑA',
	forgotPwd_msg: 'Coloque su correo electrónico en el campo de arriba, le enviaremos un enlace con las instrucciones a seguir.',
	changePwd: 'Cambia la contraseña',
	oldPwd: 'Contraseña anterior',
	newPwd: 'Nueva contraseña',
	confirmNewPwd: 'Confirmar nueva contraseña',
	user_account: 'Cuenta de usuario',
	change_pic: 'Cambiar imagen',
	mobile_number: 'Número de teléfono móvil',
	country: 'País',
	update_settings: 'ajustes de actualización',
	company: 'Empresa',
	aboutUs: 'Sobre nosotros',
	tos: 'TOS',
	copyright: 'Derechos de autor',
	socialMedia: 'Medios de comunicación social',
	forUpdates: 'para actualizaciones',
	footer_msg_1: 'Al registrarte estás aceptando',
	terms: 'Términos de servicio',
	contactUs: 'Contáctenos',
	yourEmail: 'Tu correo electrónico',
	required: 'necesario',
	yourMsg: 'Tu mensaje',
	sent: 'Expedido',
	footer_msg_2: 'Todos los derechos reservados',
	footer_msg_3: 'Todos los nombres de productos, marcas comerciales y marcas registradas son propiedad de sus respectivos dueños.',
	doom: 'Doom III',
	filter: 'Filtrar',
	add_asset: 'Agregar activo',
	request_game: 'Solicitar juego',
	search_msg: 'Lo sentimos, pero nada coincide con sus términos de búsqueda.',
	post: 'Enviar',
	asset: 'Activo',
	create: 'Crear',
	character: 'Personaje',
	characters: 'Caracteres',
	assets: 'Bienes',
	profile: 'Perfil',
	game: 'Juego',
	games: 'Juegos',
	currency: 'Moneda',
	store: 'Tienda',
	all_time: 'Todo el tiempo',
	this_month: 'Este mes',
	trending: 'Tendencias',
	item_name: 'Nombre del árticulo',
	view_item: 'Ver ítem',
	leaderboard: 'Tabla de clasificación',
	posters: 'Carteles',
	chinese: 'chino',
	english: 'Inglés',
	japanese: 'japonés',
	korean: 'coreano',
	german: 'alemán',
	french: 'francés',
	spanish: 'Español',
	italian: 'italiano',
	russian: 'ruso',
	portuguese: 'portugués',
	hindi: 'hindi',
	arabic: 'Arábica',
	buy: 'Comprar',
	subscription: 'Suscripción',
	buy_subscription: 'Comprar suscripción',
	gift: 'Regalo',
	xchange: 'Xchange',
	subscription_plan: 'Plan de suscripción',
	payment_options: 'Opciones de pago',
	cardholder_name: 'Nombre del titular de la tarjeta',
	submit_order: 'Orden de envio',
	card_number: 'Número de tarjeta',
	cvv: 'CVV',
	expiration_date: 'Fecha de caducidad',
	buyXchange: 'Comprar Xchange',
	giftXchange: 'Gift Xchange',
	or: 'o',
	select: 'Seleccione',

	search: 'Buscar',
	search_games: 'Buscar juegos ...',
	search_assets: 'Buscar activos ...',
	platform: 'Plataforma',
	total_posts: 'Publicaciones totales',
	total_comments: 'Comentarios totales',
	total_characters: 'Personajes totales',
	total_assets: 'Los activos totales',
	xchange_currency: 'Xchange Currency',
	subscription_days_remaining: 'Días de suscripción restantes',
	total_asset_networth: 'Total de activos Networth',
	total_character_networth: 'Total Character Networth',
	most_downloaded: 'Más descargados',
	recently_added: 'Recientemente añadido',
	genre: 'Género',
	my_library: 'Mi biblioteca',
	most_commented: 'Más comentado',
	most_recent: 'Más reciente',
	nearing_addition: 'Adición próxima',
	create_asset: 'Crear activo',
	create_character: 'Crear personaje',
	asset_name: 'Nombre de activo',
	asset_type: 'Tipo de activo',
	rarity: 'Rareza',
	enhancements: 'Mejoras',
	add: 'Añadir',
	currency_type: 'Tipo de cambio monetario',
	price: 'Precio',
	description: 'Descripción',
	upload_asset: 'Subir activo',
	preview_asset: 'Vista previa de activo',
	main_image: 'Imagen principal',
	upload_video: 'Subir video',
	upload: 'Subir',
	view_demo: 'Ver demostración',
	character_name: 'Nombre del personaje',
	character_type: 'Tipo de caracter',
	upload_character: 'Cargar personaje',
	preview_character: 'Vista previa del personaje',
	race: 'Carrera',
	class: 'Clase',
	gender: 'Género',
	level: 'Nivel',
	showing: 'Demostración',
	of: 'de',
	results: 'resultados',
	featured_characters: 'Personajes destacados',
	url: 'URL',
	submit: 'Enviar',
	real_world: 'Mundo real',
	game_currency: 'Moneda del juego',
	all: 'Todas',

	edit: 'Editar',
	save: 'Salvar',
	agg_character_networth: 'Carácter agregado Networth',
	agg_time_played: 'Tiempo agregado jugado',
	agg_asset_value: 'Valor agregado del activo',
	enter_character_creation_date: 'Ingrese la fecha de creación del personaje',
	in_game_currency: 'En la moneda del juego',
	real_world_value: 'Valor del mundo real',
	update_character: 'Actualizar personaje',
	item_not_found: '¡Objeto no encontrado!',
	ripper: 'Destripador',
	comments: 'Comentarios',
	add_comments: 'Añadir comentarios',
	new_suggested_price: 'Nuevo precio sugerido',
	sort_by: 'Ordenar por',
	reply: 'Respuesta',
	asset_networth: 'Activo Networth',
	join_date: 'Fecha de Ingreso',
	report: 'Reporte',
	first: 'primero',
	last: 'Último',
	most_replies: 'La mayoría de las respuestas',
	new_pricing_recommendations: 'Nuevas recomendaciones de precios',
	xchange_amount: 'Cantidad de cambio',
	username: 'Nombre de usuario',
	send_gift: 'Enviar regalo',
	message: 'Mensaje',
	gift_text: 'Personaliza tu mensaje aquí',
	day: 'día',
	days: 'dias',
	currency_converter: 'Convertidor de moneda',
	from: 'De',
	to: 'A',
	in_game: 'En el juego',
	real_life: 'Vida real',
	cvc: 'CVC',
	card: 'Tarjeta',
	per_month: 'Mensual ($ 3 por mes)',
	per_year: 'Anual ($ 30 por año)',
	aboutUs_text: 'DigitXChange es un sitio web impulsado por la comunidad que tiene como objetivo finalmente valorar el valor de los bienes y servicios digitales a través del abastecimiento público. Si alguna vez has hecho la pregunta "¿cuánto vale realmente mi personaje" o "Me pregunto qué sería un intercambio justo con otro jugador en otro juego", no busques más las respuestas. ¡Esperamos que disfrute de nuestro sitio, participe en la construcción del conocimiento grupal, muestre su botín ganado con esfuerzo y, en última instancia, espere descubrir su valor neto digital total!',
	home: 'Página principal',
	all_time_characters: 'Personajes de todos los tiempos',
	this_month_characters: 'Personajes de este mes',
	trending_characters: 'Personajes de tendencia',
	all_time_posters: 'Carteles de todos los tiempos',
	this_month_posters: 'Este mes pósters',
	trending_posters: 'Carteles de tendencia',
	
};

export default sp;


// WEBPACK FOOTER //
// ./src/translations/sp.js